var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"aiyy-test"}},[_c('MainHeader',{attrs:{"cState":"AI应用"}}),_c('div',{staticClass:"bottomWrap"},[_c('LeftNav',{attrs:{"cParent":"名医AI"}}),_c('div',{staticClass:"rightWrap"})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }